/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
function bindImageZoom() {
  document.querySelectorAll('.product__media-image-wrapper').forEach(function(wrapper) {
    if (wrapper.dataset.zoomBound) return;
    wrapper.dataset.zoomBound = 'true';
    wrapper.style.cursor = 'zoom-in';
    wrapper.addEventListener('click', function() {
      const zoomBtn = this.closest('.product__media').querySelector('.product__zoom-button');
      if (zoomBtn) zoomBtn.click();
    });
  });
}

document.addEventListener('DOMContentLoaded', bindImageZoom);
document.addEventListener('shopify:section:load', bindImageZoom);
setTimeout(bindImageZoom, 1000);
setTimeout(bindImageZoom, 2500);

/**
 * 列表页筛选：去掉值为空的 query（例如 filter.v.price.gte= / filter.v.price.lte=）。
 */
function stripEmptyQueryParams(input) {
  var url;
  try {
    url = new URL(input, window.location.origin);
  } catch (e) {
    return input;
  }

  var cleaned = new URLSearchParams();
  url.searchParams.forEach(function (value, key) {
    if (String(value).trim() === '') return;
    cleaned.append(key, value);
  });

  url.search = cleaned.toString();
  return url.pathname + url.search + url.hash;
}

document.addEventListener('facet:criteria-changed', function (event) {
  if (!event.detail || !event.detail.url) return;
  event.detail.url = stripEmptyQueryParams(event.detail.url);
}, true);

/**
 * 列表页：主图颜色对齐底部色圈。
 * 主图经常是未绑定 variant 的 featured 图（如 1_xxx.jpg），不能只靠 media id / CSS 色值。
 * 用主图裙身取样，再和各颜色 variant 图取样比对，选最接近的色圈并移到前 4 个可见位。
 */
(function bindCollectionSwatchMatch() {
  var MATCHED_ATTR = 'data-swatch-matched';
  var sampleCache = {};

  function slug(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_|_$/g, '');
  }

  function rgbToHsl(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
      else if (max === g) h = ((b - r) / d + 2) / 6;
      else h = ((r - g) / d + 4) / 6;
    }
    return { h: h * 360, s: s, l: l };
  }

  function colorDist(a, b) {
    var ha = rgbToHsl(a.r, a.g, a.b);
    var hb = rgbToHsl(b.r, b.g, b.b);
    var dh = Math.min(Math.abs(ha.h - hb.h), 360 - Math.abs(ha.h - hb.h));
    if (ha.s < 0.15 && hb.s < 0.15) {
      return Math.abs(ha.l - hb.l) * 220 + dh * 0.15;
    }
    return dh * 1.35 + Math.abs(ha.s - hb.s) * 70 + Math.abs(ha.l - hb.l) * 90;
  }

  function fileName(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function pickByFilename(file, inputs) {
    var fileSlug = slug(fileName(file));
    var best = null;
    var bestLen = 0;
    Array.prototype.forEach.call(inputs, function (input) {
      var color = slug(input.value);
      if (color.length < 4) return;
      if (fileSlug.indexOf(color) !== -1 && color.length > bestLen) {
        best = input;
        bestLen = color.length;
      }
    });
    return best;
  }

  function dressColor(img) {
    var canvas = document.createElement('canvas');
    var w = 48;
    var h = 64;
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, w, h);
    // 裙身中下区域，避开脸，不过滤黄/粉/金色
    var data = ctx.getImageData(12, 22, 24, 28).data;
    var r = 0;
    var g = 0;
    var b = 0;
    var n = 0;
    for (var i = 0; i < data.length; i += 4) {
      var R = data[i];
      var G = data[i + 1];
      var B = data[i + 2];
      var A = data[i + 3];
      if (A < 200) continue;
      var max = Math.max(R, G, B);
      var min = Math.min(R, G, B);
      if (max > 248 && min > 235) continue;
      r += R;
      g += G;
      b += B;
      n++;
    }
    if (!n) return null;
    return { r: r / n, g: g / n, b: b / n };
  }

  // 采样缩略图 URL（比色用 80px 小图，走缓存键）
  // 参数 url：任意 CDN 图片 URL
  function thumbUrl(url) {
    return withWidth(url, 80);
  }

  // 把 CDN 图片 URL 的 width 参数替换为指定值，返回新 URL（Shopify CDN 按 width 参数出图）
  // 参数 url：带 ?width= 的 CDN URL（协议相对也可，基于当前页解析）；width：目标宽度数字
  // 使用场景：比色采样（thumbUrl）、动态建图的 src/srcset（ensureVariantImage）
  function withWidth(url, width) {
    try {
      var u = new URL(url, window.location.href);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return String(url).split('?')[0] + '?width=' + width;
    }
  }

  // 由单个 CDN URL 生成响应式 srcset 字符串，如 "…w=200 200w, …w=400 400w"
  // 参数 url：CDN 图片 URL；widths：候选宽度数组（与 SSR 预渲染图保持同 3 档 200-600）
  // 使用场景：ensureVariantImage 动态建 <img> 时拼 srcset
  function srcsetFrom(url, widths) {
    return widths.map(function (w) {
      return withWidth(url, w) + ' ' + w + 'w';
    }).join(', ');
  }

  function sampleUrl(url) {
    if (!url) return Promise.reject();
    var key = thumbUrl(url);
    if (sampleCache[key]) return sampleCache[key];

    sampleCache[key] = new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          resolve(dressColor(img));
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = reject;
      img.src = key;
    });

    return sampleCache[key];
  }

  // 前 4 色之外的图不在 SSR 输出里（控制集合页 HTML 体积），
  // 按色圈 radio 携带的 CDN URL（data-variant-media-src / data-variant-back-src）动态建 <img>。
  // 幂等：已存在（SSR 预渲染或本次会话已建）直接返回；URL 缺失（该色无图）返回 null。
  // 参数：card＝商品卡元素（product-item）；input＝色圈 radio（携带 data-variant-featured-media
  //       与图 URL data 属性）；kind＝'primary'（换主图）| 'secondary'（换背面图）
  // 使用场景：hover 色圈预建图（mouseover handler）、切色换图（swapToColor）、背面图同步（syncSecondaryImage）
  // 作用：建出的 <img> 带 hidden + loading=eager（即刻下载），class/data 属性与 SSR 预渲染图同构，
  //       插入卡片图容器末尾，供后续 hidden 切换逻辑统一处理
  function ensureVariantImage(card, input, kind) {
    var mediaId = input.getAttribute('data-variant-featured-media');
    if (!mediaId) return null;

    var isPrimary = kind === 'primary';
    var selector = isPrimary
      ? '.product-item__aspect-ratio .product-item__primary-image[data-media-id="' + mediaId + '"]'
      : '.product-item__secondary-image[data-primary-media-id="' + mediaId + '"]';
    var existing = card.querySelector(selector);
    if (existing) return existing;

    var src = input.getAttribute(isPrimary ? 'data-variant-media-src' : 'data-variant-back-src');
    if (!src) return null;

    var reference = card.querySelector(isPrimary ? '.product-item__primary-image' : '.product-item__secondary-image');
    if (!reference) return null;

    var img = document.createElement('img');
    if (isPrimary) {
      img.className = 'product-item__primary-image';
      img.setAttribute('data-media-id', mediaId);
    } else {
      img.className = 'product-item__secondary-image';
      img.setAttribute('data-primary-media-id', mediaId);
    }
    img.setAttribute('hidden', '');
    img.setAttribute('loading', 'eager');
    if (reference.getAttribute('sizes')) {
      img.setAttribute('sizes', reference.getAttribute('sizes'));
    }
    img.alt = reference.alt;
    img.srcset = srcsetFrom(src, [200, 400, 600]);
    img.src = withWidth(src, 600);
    reference.parentElement.appendChild(img);
    // theme.js 在 connectedCallback 里快照了主图列表，动态补的图要补进去，否则之后点色圈换不掉这张
    if (isPrimary && card.primaryImageList && card.primaryImageList.indexOf(img) === -1) {
      card.primaryImageList.push(img);
    }
    return img;
  }

  // 卡片主图切换显示：隐藏卡内全部 primary <img>，仅显示目标图
  // 参数：card＝商品卡元素；img＝要显示的 primary <img>（SSR 预渲染或动态建）
  // 使用场景：swapToColor（切色/比色选中后的换图显示）
  function showPrimaryImage(card, img) {
    Array.prototype.forEach.call(card.querySelectorAll('.product-item__primary-image'), function (el) {
      el.setAttribute('hidden', '');
    });
    img.removeAttribute('hidden');
  }

  // 切色（change 事件）换图入口
  // 参数：card＝商品卡元素；input＝被选中的色圈 radio
  // 使用场景：custom.js 的 change handler（用户点色圈/键盘选中），
  //           与 theme.js 的 _onColorSwatchChanged 并行——预渲染色两者幂等，
  //           动态色（无 SSR img）由这里接管：建图 → 加载完成且仍选中 → 切显示 → 同步背面图
  // 作用：动态色的图加载完再切换显示，避免闪空白；同时驱动 syncSecondaryImage
  function swapToColor(card, input) {
    var primary = ensureVariantImage(card, input, 'primary');
    if (primary) {
      if (primary.complete && primary.naturalWidth > 0) {
        showPrimaryImage(card, primary);
      } else {
        primary.addEventListener('load', function () {
          if (input.checked) {
            showPrimaryImage(card, primary);
          }
        }, { once: true });
      }
    }
    syncSecondaryImage(card, input);
  }

  // 背面图（hover 副图）与所选颜色同步：显示 data-primary-media-id 匹配的 secondary <img>
  // 参数：card＝商品卡元素；input＝色圈 radio（此前版本传 primaryMediaId 字符串，现改传 input
  //       以便动态建背面图）；无匹配时回退显示第一张 secondary
  // 使用场景：swapToColor（切色）、apply（比色选中/初始化对齐）
  function syncSecondaryImage(card, input) {
    var primaryMediaId = input && input.getAttribute('data-variant-featured-media');
    if (primaryMediaId && input.getAttribute('data-variant-back-src')) {
      ensureVariantImage(card, input, 'secondary');
    }

    var seconds = card.querySelectorAll('.product-item__secondary-image');
    if (!seconds.length) return;

    var matched = false;
    Array.prototype.forEach.call(seconds, function (img) {
      if (primaryMediaId && img.getAttribute('data-primary-media-id') === String(primaryMediaId)) {
        img.removeAttribute('hidden');
        img.setAttribute('loading', 'eager');
        matched = true;
      } else {
        img.setAttribute('hidden', '');
      }
    });

    if (!matched) {
      seconds[0].removeAttribute('hidden');
    }
  }

  function apply(card, input) {
    if (!input) return;
    var list = card.querySelector('.product-item-meta__swatch-list');
    if (!list) return;

    Array.prototype.forEach.call(list.querySelectorAll('.color-swatch__radio'), function (el) {
      el.checked = el === input;
    });

    var swatch = input.closest('.color-swatch');
    if (swatch && list.firstElementChild !== swatch) {
      list.insertBefore(swatch, list.firstElementChild);
    }

    // 主图经常是未绑定变体的 featured 图（如 1_22.jpg）。比色只改色圈时，
    // hover 背面图已换成选中色，首屏主图仍是另一色。这里把主图也换成该色正面图。
    var targetId = String(input.getAttribute('data-variant-featured-media') || '');
    var visible = card.querySelector('.product-item__primary-image:not([hidden])');
    var visibleId = visible ? String(visible.getAttribute('data-media-id') || '') : '';
    if (targetId && visibleId !== targetId) {
      swapToColor(card, input);
    } else {
      syncSecondaryImage(card, input);
    }

    // 让卡片指向详情页的链接带上当前展示颜色的变体，避免点进去回退到第一个颜色。
    // 覆盖 SSR 无法判定的场景：product.featured_media 是通用主图（不等于任何变体图）时，
    // 显示色由上面的比色 matchCard 决定，只有这里知道选中的是哪个颜色变体。
    // 与 theme.js 的 _onColorSwatchChanged（用户手动切色时更新链接）逻辑一致。
    var variantId = input.getAttribute('data-variant-id');
    if (variantId) {
      Array.prototype.forEach.call(card.querySelectorAll('[href*="/products"]'), function (link) {
        var raw = link.tagName === 'A' ? link.href : link.getAttribute('href');
        if (!raw) return;
        try {
          var url = new URL(raw, window.location.origin);
          url.searchParams.set('variant', variantId);
          link.setAttribute('href', url.toString());
        } catch (e) {}
      });
    }

    card.setAttribute(MATCHED_ATTR, 'true');

    // 比色选中不会触发 change。通知收藏组件按当前颜色刷新心形。
    card.dispatchEvent(new CustomEvent('wishlist:color', { bubbles: true }));
  }

  function matchCard(card) {
    if (!card || card.getAttribute(MATCHED_ATTR)) return;

    var list = card.querySelector('.product-item-meta__swatch-list');
    var img = card.querySelector('.product-item__primary-image:not([hidden])') || card.querySelector('.product-item__primary-image');
    if (!img || !list) return;

    var mediaId = String(img.getAttribute('data-media-id') || '');
    var inputs = list.querySelectorAll('.color-swatch__radio');
    var i;
    var input;

    for (i = 0; i < inputs.length; i++) {
      input = inputs[i];
      if (mediaId && String(input.getAttribute('data-variant-featured-media')) === mediaId) {
        apply(card, input);
        return;
      }
    }

    var featuredSrc = img.currentSrc || img.src;
    if (!featuredSrc) {
      img.addEventListener('load', function onLoad() {
        img.removeEventListener('load', onLoad);
        matchCard(card);
      }, { once: true });
      return;
    }

    var named = pickByFilename(featuredSrc, inputs);
    if (named) {
      apply(card, named);
      return;
    }

    sampleUrl(featuredSrc).then(function (featured) {
      if (!featured || card.getAttribute(MATCHED_ATTR)) return;

      var jobs = Array.prototype.map.call(inputs, function (radio) {
        // 比色样本改从 radio 携带的 CDN URL 取（隐藏 <img> 只预渲染前 4 色，DOM 里不再全量有）
        var variantSrc = radio.getAttribute('data-variant-media-src');
        if (!variantSrc) {
          return Promise.resolve({ input: radio, d: 9999 });
        }
        return sampleUrl(variantSrc).then(function (color) {
          return { input: radio, d: color ? colorDist(featured, color) : 9999 };
        }).catch(function () {
          return { input: radio, d: 9999 };
        });
      });

      return Promise.all(jobs).then(function (results) {
        if (card.getAttribute(MATCHED_ATTR)) return;
        results.sort(function (a, b) {
          return a.d - b.d;
        });
        if (results[0] && results[0].d < 120) {
          apply(card, results[0].input);
        }
      });
    }).catch(function () {});
  }

  function matchAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('.product-item'), matchCard);
  }

  document.addEventListener('DOMContentLoaded', function () {
    matchAll(document);
  });
  document.addEventListener('shopify:section:load', function () {
    matchAll(document);
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('.product-item-meta__swatch-list .color-swatch__radio')) return;
    var card = input.closest('product-item, .product-item');
    if (!card) return;
    swapToColor(card, input);
  }, true);

  // 悬停色圈即预建图（与 theme.js 对预渲染图的 loading=eager 预加载行为对齐），
  // 点击切色时图已就位，动态色也能即时换图
  document.addEventListener('mouseover', function (event) {
    var label = event.target;
    if (!label || !label.matches || !label.matches('.product-item-meta__swatch-list .color-swatch__item')) return;
    var input = label.previousElementSibling;
    if (!input || !input.matches || !input.matches('.color-swatch__radio')) return;
    var card = input.closest('product-item, .product-item');
    if (!card) return;
    ensureVariantImage(card, input, 'primary');
    ensureVariantImage(card, input, 'secondary');
  }, true);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('.product-item, product-item')) {
            matchCard(node);
          } else if (node.querySelectorAll) {
            matchAll(node);
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/**
 * ------------------------------------------------------------------------------------------------------------
 * MOBILE INFINITE SCROLL / LOAD MORE (<load-more>)
 * ------------------------------------------------------------------------------------------------------------
 *
 * Turns the list pages (collection / search / list-collections) into a "waterfall" experience on the mobile
 * (phone) breakpoint: products are appended to the existing grid as the shopper scrolls, with a "Load more"
 * button as a fallback and a "Viewing X of Y" progress counter.
 *
 * On tablet & desktop this element stays inert — the theme keeps its numbered pagination, which also serves as
 * the crawlable SEO fallback (rendered but hidden on phone via CSS).
 *
 * Rendered by snippets/pagination.liquid when `infinite: true` is passed. Relevant attributes:
 *   - section-id         : section id, used to fetch a rendered section fragment (?section_id=)
 *   - content-container  : CSS selector of the grid container that receives appended items
 *   - item-selector      : CSS selector of a single item (used to count loaded items)
 *   - total              : total number of items across all pages
 *   - count-template     : localized "Viewing {loaded} of N" template, {loaded} is replaced at runtime
 *   - next-url           : URL of the next page (absent on the last page)
 */
(function () {
  // Inject the styling once.
  if (!document.getElementById('load-more-styles')) {
    var style = document.createElement('style');
    style.id = 'load-more-styles';
    style.textContent = [
      '.load-more{display:flex;flex-direction:column;align-items:center;gap:14px;margin-top:24px;text-align:center;}',
      '.load-more__count{margin:0;font-size:0.8125rem;letter-spacing:0.02em;color:rgb(var(--text-color));opacity:0.7;}',
      '.load-more__button{min-width:220px;}',
      '.load-more__status{display:none;align-items:center;justify-content:center;gap:8px;min-height:44px;color:rgb(var(--text-color));font-size:0.8125rem;letter-spacing:0.02em;}',
      '.load-more[loading] .load-more__status{display:flex;}',
      '.load-more[loading] .load-more__button{display:none;}',
      '.load-more__status .spinner{width:24px;height:24px;}',
      '.load-more__end{margin:8px 0 0;font-size:0.75rem;letter-spacing:0.12em;text-transform:uppercase;color:rgb(var(--text-color));opacity:0.55;}',
      '.load-more__end[hidden]{display:none;}'
    ].join('');
    document.head.appendChild(style);
  }

  var PHONE_QUERY = (window.themeVariables &&
    window.themeVariables.breakpoints &&
    window.themeVariables.breakpoints.phone) || 'screen and (max-width: 740px)';

  // Start the next page once the shopper has scrolled the footer near the screen,
  // so the bottom spinner is visible for the whole request.
  var PREFETCH_MARGIN = 120;

  window.customElements.define('load-more', class extends HTMLElement {
    connectedCallback() {
      this.mql = window.matchMedia(PHONE_QUERY);
      // Only enable the waterfall behavior on phones. Desktop/tablet keep numbered pagination.
      if (!this.mql.matches) return;

      this.loading = false;
      this.button = this.querySelector('[data-load-more-button]');
      this.countElement = this.querySelector('[data-load-more-count]');
      this.endElement = this.querySelector('[data-load-more-end]');

      if (this.button) {
        this._onClick = this._loadNext.bind(this);
        this.button.addEventListener('click', this._onClick);
      }

      // Auto-load when the element scrolls into view (with a generous margin so it feels seamless).
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            this._loadNext();
          }
        }.bind(this), { rootMargin: PREFETCH_MARGIN + 'px 0px', threshold: 0 });
        this.observer.observe(this);
      }

      // Back from a product restores this page from bfcache. connectedCallback does not run again,
      // an in-flight fetch stays stuck on `loading`, and the observer will not re-fire while the
      // sentinel is already on screen — so "load more" still shows remaining items but nothing loads.
      this._onPageShow = function (event) {
        if (!event.persisted || !this.isConnected || !this.mql.matches) return;
        // Drop ownership of any fetch frozen by the browser so its finally block
        // cannot clear the flag or start a second request after we resume.
        this._requestToken = null;
        this.loading = false;
        this.removeAttribute('loading');
        if (this._abortController) {
          this._abortController.abort();
          this._abortController = null;
        }
        if (!this.nextUrl) return;
        if (this.observer) {
          this.observer.disconnect();
          this.observer.observe(this);
        } else {
          this._loadNext();
        }
      }.bind(this);
      window.addEventListener('pageshow', this._onPageShow);

      this._updateCount();
    }

    disconnectedCallback() {
      if (this._onPageShow) window.removeEventListener('pageshow', this._onPageShow);
      if (this._abortController) this._abortController.abort();
      if (this.observer) this.observer.disconnect();
      if (this.button && this._onClick) this.button.removeEventListener('click', this._onClick);
    }

    get nextUrl() {
      return this.getAttribute('next-url');
    }

    get container() {
      var selector = this.getAttribute('content-container');
      if (!selector) return null;
      // Scope to the surrounding product-facet when present (search page can hold several lists),
      // otherwise fall back to the document (e.g. the /collections list page).
      var scope = this.closest('product-facet') || document;
      return scope.querySelector(selector) || document.querySelector(selector);
    }

    _updateCount() {
      if (!this.countElement) return;
      var template = this.getAttribute('count-template');
      var container = this.container;
      var itemSelector = this.getAttribute('item-selector');
      if (!template || !container) return;
      var loaded = itemSelector
        ? container.querySelectorAll(itemSelector).length
        : container.children.length;
      this.countElement.textContent = template.replace('LOADED_TOKEN', loaded);
    }

    // True while the sentinel is inside the same prefetch band the observer uses.
    // The observer only notifies on a change, so a sentinel that stays on screen
    // after one page would otherwise stop the waterfall early.
    _withinPrefetchRange() {
      var rect = this.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      return rect.top <= viewportHeight + PREFETCH_MARGIN && rect.bottom >= -PREFETCH_MARGIN;
    }

    _sameUrl(left, right) {
      try {
        return new URL(left, window.location.origin).href === new URL(right, window.location.origin).href;
      } catch (error) {
        return left === right;
      }
    }

    _finish() {
      this.removeAttribute('next-url');
      // Remove (not just [hidden]) — the theme's .button rule overrides [hidden]{display:none}.
      if (this.button) { this.button.remove(); this.button = null; }
      if (this.endElement) this.endElement.hidden = false;
      if (this.observer) this.observer.disconnect();
    }

    async _loadNext(isContinuation) {
      if (!this.nextUrl || !this.isConnected) return;
      // A continuation keeps the bottom spinner up across the next page of the same gesture.
      if (this.loading && !isContinuation) return;
      var requestedUrl = this.nextUrl;
      var requestToken = {};
      this._requestToken = requestToken;
      this.loading = true;
      this.setAttribute('loading', '');
      if (this._abortController) this._abortController.abort();
      this._abortController = typeof AbortController === 'function' ? new AbortController() : null;
      var advanced = false;

      try {
        var fetchUrl = new URL(requestedUrl, window.location.origin);
        fetchUrl.searchParams.set('section_id', this.getAttribute('section-id'));

        var response = await fetch(fetchUrl.toString(), {
          signal: this._abortController ? this._abortController.signal : undefined
        });
        if (this._requestToken !== requestToken) return;
        if (!response.ok) throw new Error('load-more: ' + response.status);
        var responseText = await response.text();
        if (this._requestToken !== requestToken) return;

        var fakeDiv = document.createElement('div');
        fakeDiv.innerHTML = responseText;

        var selector = this.getAttribute('content-container');
        var liveContainer = this.container;
        var newContainer = selector ? fakeDiv.querySelector(selector) : null;
        // A fragment without the grid is not the last page. Keep the button so the shopper can retry.
        if (!liveContainer || !newContainer) throw new Error('load-more: missing product list');

        var fragment = document.createDocumentFragment();
        Array.prototype.slice.call(newContainer.children).forEach(function (child) {
          // The theme hides elements carrying the `reveal` attribute (CSS: [reveal]{opacity:0})
          // and only animates the initially-rendered items back to opacity:1. Appended items are
          // never part of that animation, so strip the reveal attributes to make them visible.
          if (child.nodeType === 1) {
            child.removeAttribute('reveal');
            child.removeAttribute('reveal-visibility');
            if (child.querySelectorAll) {
              Array.prototype.forEach.call(
                child.querySelectorAll('[reveal],[reveal-visibility]'),
                function (el) { el.removeAttribute('reveal'); el.removeAttribute('reveal-visibility'); }
              );
            }
          }
          fragment.appendChild(child);
        });
        liveContainer.appendChild(fragment);

        // Keep the list URL on page 1. Writing ?page=N into history made "back from a product"
        // reopen a later page, which rendered as the end of the list while earlier items were gone.
        var newLoadMore = fakeDiv.querySelector('load-more');
        if (!newLoadMore) throw new Error('load-more: missing next page marker');
        var newNextUrl = newLoadMore.getAttribute('next-url');

        if (newNextUrl && !this._sameUrl(newNextUrl, requestedUrl)) {
          this.setAttribute('next-url', newNextUrl);
          advanced = true;
        } else if (!newNextUrl) {
          this._finish();
        }

        this._updateCount();
      } catch (error) {
        if (this._requestToken !== requestToken) return;
        if (error && error.name === 'AbortError') return;
        // Network / render error: re-enable the button so the shopper can retry.
        if (window.console) console.warn(error);
      } finally {
        if (this._requestToken === requestToken) {
          var stillAtBottom = advanced && this.nextUrl && this.isConnected && this._withinPrefetchRange();
          // Leave the spinner up when the next page starts immediately. Otherwise wait until
          // this response has been appended, then hide it.
          if (!stillAtBottom) {
            this.loading = false;
            this.removeAttribute('loading');
          }
        }
      }

      // The shopper is still at the bottom and another page exists: keep loading.
      // If the new products pushed the footer down, wait for the next scroll.
      if (advanced && this._requestToken === requestToken && this.nextUrl && this.isConnected && this._withinPrefetchRange()) {
        this._loadNext(true);
      }
    }
  });
})();

/**
 * 集合页色系圈：桌面悬停 / 手机点击展开子色，点击后走 Focal 的 facet Ajax 筛选。
 */
(function bindCollectionColorFamilyNav() {
  var ITEM_SELECTOR = '.color-family-nav__item';
  var MOBILE_QUERY = '(max-width: 989px)';

  if (window.customElements.get('color-family-nav')) return;

  var ColorFamilyNav = class extends HTMLElement {
    constructor() {
      super();
      this._onMediaChange = this._onMediaChange.bind(this);
      this._onDocumentFilter = this._onDocumentFilter.bind(this);
      this._cancelClose = this._cancelClose.bind(this);
      this._scheduleClose = this._scheduleClose.bind(this);
      this.close = this.close.bind(this);
      this._onOutsideClick = this._onOutsideClick.bind(this);
    }

    connectedCallback() {
      this.scroller = this.querySelector('.color-family-nav__scroller');
      this.items = Array.prototype.slice.call(this.querySelectorAll(ITEM_SELECTOR));
      this.media = window.matchMedia(MOBILE_QUERY);
      this._bindItems();
      this.addEventListener('click', this._onClick.bind(this), true);
      this.addEventListener('mouseenter', this._cancelClose);
      this.addEventListener('mouseleave', this._scheduleClose);
      this.media.addListener(this._onMediaChange);
      document.addEventListener('facet:criteria-changed', this._onDocumentFilter);
      document.addEventListener('click', this._onOutsideClick, true);
      this.syncFromUrl(new URL(window.location.href));
    }

    disconnectedCallback() {
      if (this.media && this.media.removeListener) this.media.removeListener(this._onMediaChange);
      document.removeEventListener('facet:criteria-changed', this._onDocumentFilter);
      document.removeEventListener('click', this._onOutsideClick, true);
    }

    // 弹框展开后，点色圈和白色面板以外的区域就收起，并且不要把这次点击传给下面的商品。
    _onOutsideClick(event) {
      if (!this.querySelector('.color-family-nav__popover.is-appended')) return;
      if (this.contains(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }

    _onMediaChange() {
      this.close();
      this._bindItems();
    }

    _bindItems() {
      var isMobile = this.media.matches;
      var eventName = isMobile ? 'click' : 'pointerenter';
      this.items.forEach(function (item) {
        if (item._ccgHandler) item.removeEventListener(item._ccgEvent, item._ccgHandler);
        var handler = isMobile
          ? this._onMobileToggle.bind(this)
          : this._onDesktopEnter.bind(this);
        item._ccgEvent = eventName;
        item._ccgHandler = handler;
        item.addEventListener(eventName, handler);
      }.bind(this));
    }

    _onClick(event) {
      var link = event.target.closest('[data-color-family-filter]');
      if (!link || !this.contains(link)) return;
      event.preventDefault();
      event.stopPropagation();
      this._applyColorFilter(link);
    }

    _onMobileToggle(event) {
      if (event.target.closest('.color-family-nav__handle-link')) return;
      if (event.target.closest('[data-color-family-filter]')) return;
      if (event.currentTarget.classList.contains('is-active')) {
        this.close();
        return;
      }
      this._openItem(event);
    }

    _onDesktopEnter(event) {
      if (event.target.closest('.color-family-nav__handle-link')) return;
      this._cancelClose();
      var item = event.currentTarget;
      if (item.classList.contains('is-active') && this.querySelector('.color-family-nav__popover.is-appended')) return;
      this._openItem(event);
    }

    _cancelClose() {
      clearTimeout(this._closeTimer);
    }

    _scheduleClose() {
      if (this.media.matches) return;
      clearTimeout(this._closeTimer);
      this._closeTimer = setTimeout(this.close, 160);
    }

    _openItem(event) {
      var item = event.currentTarget;
      this._resetFamilyState();
      if (!item.querySelector('.color-family-nav__popover')) return;

      item.classList.add('is-active');
      var trigger = item.querySelector('.color-family-nav__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      var navWidth = this.offsetWidth;
      var itemWidth = item.offsetWidth;
      var itemLeftInScroller = item.getBoundingClientRect().left - this.scroller.getBoundingClientRect().left + this.scroller.scrollLeft;
      var targetScroll = itemLeftInScroller - navWidth / 2 + itemWidth / 2;
      var maxScroll = Math.max(0, this.scroller.scrollWidth - navWidth);
      var scrollLeft = Math.min(Math.max(targetScroll, 0), maxScroll);
      this.scroller.scrollTo({ left: scrollLeft, behavior: 'smooth' });

      var caretX = itemLeftInScroller - scrollLeft + itemWidth / 2;

      this._showPopover(item, caretX);

      if (this.media.matches) return;
      var index = this.items.indexOf(item);
      if (index > 0) this.items[index - 1].classList.add('is-neighbor-1');
      if (index > 1) this.items[index - 2].classList.add('is-neighbor-2');
      if (index < this.items.length - 1) this.items[index + 1].classList.add('is-neighbor-1');
      if (index < this.items.length - 2) this.items[index + 2].classList.add('is-neighbor-2');
    }

    _showPopover(item, caretX) {
      var source = item.querySelector('.color-family-nav__popover');
      if (!source) return;
      var clone = source.cloneNode(true);
      clone.classList.add('is-appended');
      clone.removeAttribute('hidden');
      this.appendChild(clone);
      document.body.classList.add('color-family-nav-open');

      var panel = clone.querySelector('.color-family-nav__panel');
      if (this.media.matches) {
        clone.addEventListener('click', function (event) {
          if (event.target === clone) this.close();
        }.bind(this));
      }

      var panelWidth = panel.offsetWidth;
      var navWidth = this.offsetWidth;
      var panelLeft;
      if (caretX < panelWidth / 2) panelLeft = 5;
      else if (caretX + panelWidth / 2 > navWidth) panelLeft = navWidth - panelWidth - 5;
      else panelLeft = caretX - panelWidth / 2;
      panel.style.left = panelLeft + 'px';
      panel.style.transform = 'translateX(0)';

      Array.prototype.forEach.call(clone.querySelectorAll('.color-family-nav__caret, .color-family-nav__caret-fill'), function (caret) {
        caret.style.left = caretX + 'px';
      });
    }

    _resetFamilyState() {
      this.items.forEach(function (item) {
        item.classList.remove('is-active', 'is-neighbor-1', 'is-neighbor-2');
        var trigger = item.querySelector('.color-family-nav__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      Array.prototype.forEach.call(this.querySelectorAll('.color-family-nav__popover.is-appended'), function (node) {
        node.remove();
      });
    }

    close() {
      this._cancelClose();
      this._resetFamilyState();
      document.body.classList.remove('color-family-nav-open');
    }

    _applyColorFilter(link) {
      var param = link.getAttribute('data-filter-param') || this.getAttribute('data-color-filter-param') || 'filter.v.option.color';
      var value = link.getAttribute('data-filter-value');
      if (!value) return;

      this.close();

      var url = new URL(window.location.href);
      var current = url.searchParams.getAll(param);
      var alreadySelected = current.length === 1 && current[0] === value;
      url.searchParams.delete(param);
      url.searchParams.delete('page');
      if (!alreadySelected) url.searchParams.append(param, value);

      var cleanedUrl = stripEmptyQueryParams(url.pathname + url.search + url.hash);

      this._markSelected(alreadySelected ? '' : value);

      var facet = document.querySelector('product-facet');
      if (facet) {
        facet.dispatchEvent(new CustomEvent('facet:criteria-changed', {
          bubbles: true,
          detail: { url: cleanedUrl }
        }));
      } else {
        window.location.href = cleanedUrl;
      }
    }

    _onDocumentFilter(event) {
      if (!event.detail || !event.detail.url) return;
      this.syncFromUrl(new URL(event.detail.url, window.location.origin));
    }

    syncFromUrl(url) {
      var param = this.getAttribute('data-color-filter-param') || 'filter.v.option.color';
      var selected = url.searchParams.getAll(param);
      this._markSelected(selected.length === 1 ? selected[0] : '');
      if (selected.length > 1) {
        this.items.forEach(function (item) {
          var colors = item.querySelectorAll('[data-color-family-filter]');
          var familyOn = false;
          Array.prototype.forEach.call(colors, function (chip) {
            var on = selected.indexOf(chip.getAttribute('data-filter-value')) !== -1;
            chip.closest('.color-family-nav__color').classList.toggle('is-selected', on);
            if (on) familyOn = true;
          });
          item.classList.toggle('is-selected', familyOn);
        });
      }
    }

    _markSelected(value) {
      this.items.forEach(function (item) {
        var familyOn = false;
        Array.prototype.forEach.call(item.querySelectorAll('.color-family-nav__color'), function (color) {
          var chip = color.querySelector('[data-color-family-filter]');
          var on = !!(chip && chip.getAttribute('data-filter-value') === value);
          color.classList.toggle('is-selected', on);
          if (on) familyOn = true;
        });
        item.classList.toggle('is-selected', familyOn);
      });
    }
  };

  window.customElements.define('color-family-nav', ColorFamilyNav);
})();

/**
 * 商品轮播：不自动播放。左右按钮一直显示，每次滑两张。
 * 到头的按钮变淡且不可点。手机端 is-overflowing 时第三张露出约 10%。
 */
(function () {
  if (window.customElements.get('product-carousel')) return;

  var ProductCarousel = class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-product-carousel-viewport]');
      this.prevButton = this.querySelector('[data-product-carousel-prev]');
      this.nextButton = this.querySelector('[data-product-carousel-next]');
      this.stage = this.querySelector('.product-carousel__stage');
      if (!this.viewport || !this.prevButton || !this.nextButton) return;

      this._onScroll = this._syncControls.bind(this);
      this._onResize = this._update.bind(this);
      this.viewport.addEventListener('scroll', this._onScroll, { passive: true });
      this.prevButton.addEventListener('click', this._onPrev = this._prev.bind(this));
      this.nextButton.addEventListener('click', this._onNext = this._next.bind(this));
      window.addEventListener('resize', this._onResize);

      if (typeof ResizeObserver === 'function') {
        this._observer = new ResizeObserver(this._onResize);
        this._observer.observe(this);
      }

      this._update();
    }

    disconnectedCallback() {
      if (this.viewport && this._onScroll) this.viewport.removeEventListener('scroll', this._onScroll);
      if (this.prevButton && this._onPrev) this.prevButton.removeEventListener('click', this._onPrev);
      if (this.nextButton && this._onNext) this.nextButton.removeEventListener('click', this._onNext);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._observer) this._observer.disconnect();
    }

    _items() {
      return Array.from(this.viewport.querySelectorAll('[data-product-carousel-item]'));
    }

    _perRow() {
      var styles = getComputedStyle(this);
      var desktop = parseFloat(styles.getPropertyValue('--pc-per-row-desktop')) || 5;
      var mobile = parseFloat(styles.getPropertyValue('--pc-per-row-mobile')) || 2;

      if (window.matchMedia('(min-width: 1000px)').matches) return desktop;
      if (window.matchMedia('(min-width: 741px)').matches) return 3;
      return mobile;
    }

    _prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    _prev() {
      this._move(-1);
    }

    _next() {
      this._move(1);
    }

    /** 相对当前第一张，一次滚动两张。不足两张时停在首张或末张。 */
    _move(direction) {
      var items = this._items();
      var current = this.viewport.scrollLeft;
      var step = 2;
      var currentIndex = 0;
      var nextIndex;
      var index;

      for (index = 0; index < items.length; index += 1) {
        if (items[index].offsetLeft <= current + 4) currentIndex = index;
      }

      nextIndex = currentIndex + direction * step;
      if (nextIndex < 0) nextIndex = 0;
      if (nextIndex > items.length - 1) nextIndex = items.length - 1;
      if (nextIndex === currentIndex) return;

      this.viewport.scrollTo({
        left: items[nextIndex].offsetLeft,
        behavior: this._prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    _update() {
      var count = this._items().length;
      this.classList.toggle('is-overflowing', count > this._perRow());
      this._positionArrows();
      this._syncControls();
    }

    /** 箭头垂直居中在商品图上，而不是整张卡片（图 + 标题 + 价格）。 */
    _positionArrows() {
      var image = this.querySelector('.product-item__image-wrapper');
      if (!image || !this.stage) return;

      var stageTop = this.stage.getBoundingClientRect().top;
      var imageRect = image.getBoundingClientRect();
      var center = imageRect.top - stageTop + imageRect.height / 2;
      if (center > 0) this.stage.style.setProperty('--pc-arrow-top', center + 'px');
    }

    _syncControls() {
      var max = this.viewport.scrollWidth - this.viewport.clientWidth;
      var left = Math.abs(this.viewport.scrollLeft);
      var canScroll = max > 2;

      this.prevButton.hidden = false;
      this.nextButton.hidden = false;
      this.prevButton.disabled = !canScroll || left <= 2;
      this.nextButton.disabled = !canScroll || left >= max - 2;
    }
  };

  window.customElements.define('product-carousel', ProductCarousel);
})();

/**
 * 尺码表弹框打开时锁住背后页面滚动，关闭后恢复。
 * 只在详情页注册，并且只在点击尺码表或按 Esc 时执行，不监听整页样式变化。
 * 表格超出一屏时只在 .size-chart-content 内滚动。
 */
(function() {
  var productSection = document.querySelector('.shopify-section--main-product');
  if (!productSection) return;

  var lockedScrollY = 0;
  var chartControlSelector = '.product-size-chart, [data-numeric-size-chart], [data-letter-size-chart], .size-chart-mask, .size-chart-close';

  function isSizeChartOpen() {
    return Array.prototype.some.call(productSection.querySelectorAll('.size-chart-modal'), function(modal) {
      return modal.style.display === 'block' || modal.style.display === 'flex';
    });
  }

  function lockPageScroll() {
    if (document.documentElement.classList.contains('size-chart-scroll-lock')) return;

    lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('size-chart-scroll-lock');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + lockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockPageScroll() {
    if (!document.documentElement.classList.contains('size-chart-scroll-lock')) return;

    document.documentElement.classList.remove('size-chart-scroll-lock');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  }

  function syncSizeChartScrollLock() {
    if (isSizeChartOpen()) {
      lockPageScroll();
    } else {
      unlockPageScroll();
    }
  }

  productSection.addEventListener('click', function(event) {
    if (!event.target.closest(chartControlSelector)) return;
    syncSizeChartScrollLock();
  });

  document.addEventListener('keyup', function(event) {
    if (event.key !== 'Escape') return;
    syncSizeChartScrollLock();
  });
})();

/**
 * 移动端一级菜单同时只展开一项。
 * 收起上一项和滑动同时进行，滑到顶部后立刻展开。
 * 这项展开后的高度，加上它后面还没展开的项，不满一屏时不滚到顶部，只把这段完整显示出来。
 */
(function() {
  var openToken = 0;

  function drawerScroller() {
    return document.querySelector('#mobile-menu-drawer .drawer__content');
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function itemOffset(scroller, item) {
    return item.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
  }

  function maxScroll(scroller) {
    return Math.max(0, scroller.scrollHeight - scroller.clientHeight);
  }

  // 收起时高度是 0，用 scrollHeight 拿展开后的内容高度。
  function expandedPanelHeight(button) {
    var content = document.getElementById(button.getAttribute('aria-controls'));
    if (!content) return 0;
    var visible = content.getBoundingClientRect().height;
    return visible > 1 ? visible : content.scrollHeight;
  }

  function openPanelHeight(button) {
    var content = document.getElementById(button.getAttribute('aria-controls'));
    return content ? content.getBoundingClientRect().height : 0;
  }

  // 展开内容 + 后面未展开的项是否够一屏。够才滚到顶部。
  function placement(scroller, item, button) {
    var items = document.querySelectorAll('#mobile-menu-drawer .mobile-nav__item[data-level="1"]');
    var itemIndex = Array.prototype.indexOf.call(items, item);
    var above = 0;
    var all = 0;
    var after = 0;

    Array.prototype.forEach.call(items, function(otherItem, index) {
      var head = otherItem.querySelector(':scope > button, :scope > a');
      if (index > itemIndex && head) after += head.getBoundingClientRect().height;
      var other = otherItem.querySelector(':scope > button');
      if (!other || other === button || other.getAttribute('aria-expanded') !== 'true') return;
      var height = openPanelHeight(other);
      all += height;
      if (index < itemIndex) above += height;
    });

    var panel = expandedPanelHeight(button);
    var fillsScreen = panel + after >= scroller.clientHeight - 1;
    var nav = scroller.querySelector('.mobile-nav');
    var scrollerPad = parseFloat(window.getComputedStyle(scroller).paddingBottom) || 0;
    var contentSize = (nav ? nav.getBoundingClientRect().height : 0) + scrollerPad;
    var finalSize = Math.max(0, contentSize - all);
    var finalOffset = Math.max(0, itemOffset(scroller, item) - above);
    var block = button.getBoundingClientRect().height + panel + after;
    var pad = 0;

    if (fillsScreen) {
      // 列表比屏幕短时，差值也要补上，否则滚不到这项的顶部。
      pad = Math.max(0, Math.ceil(finalOffset + scroller.clientHeight - finalSize));
    }

    return {
      fillsScreen: fillsScreen,
      // 满一屏就贴顶。不满一屏时只上移到能看全的位置，不贴顶。
      targetVisual: fillsScreen ? 0 : Math.min(finalOffset, Math.max(0, scroller.clientHeight - block)),
      pad: pad
    };
  }

  function collapseOthers(currentButton) {
    var closing = [];
    var buttons = document.querySelectorAll('#mobile-menu-drawer .mobile-nav__item[data-level="1"] > button[aria-expanded="true"]');

    Array.prototype.forEach.call(buttons, function(other) {
      if (other === currentButton) return;
      var content = document.getElementById(other.getAttribute('aria-controls'));
      other.setAttribute('aria-expanded', 'false');
      if (content) closing.push(content);
    });

    return closing;
  }

  function stillClosing(closing) {
    return closing.some(function(content) {
      return content.getAnimations().some(function(animation) {
        return animation.playState === 'running';
      });
    });
  }

  // 展开内容已经能撑住当前位置时，去掉为了滚到顶部临时加的空白。
  function trimPadding(scroller) {
    var nav = scroller.querySelector('.mobile-nav');
    if (!nav || !nav.style.paddingBottom) return;
    var pad = parseFloat(nav.style.paddingBottom) || 0;
    var maxWithout = scroller.scrollHeight - pad - scroller.clientHeight;
    if (maxWithout >= scroller.scrollTop - 1) nav.style.paddingBottom = '';
  }

  // 捕获阶段拦住按钮自己的开关，避免一点击就先展开。
  document.addEventListener('click', function(event) {
    var button = event.target.closest('#mobile-menu-drawer .mobile-nav__item[data-level="1"] > button');
    if (!button) return;

    var scroller = drawerScroller();
    if (!scroller) return;

    if (button.getAttribute('aria-expanded') === 'true') {
      openToken += 1;
      window.setTimeout(function() {
        trimPadding(scroller);
      }, 520);
      return;
    }

    event.stopPropagation();
    var item = button.parentElement;
    var token = ++openToken;
    var nav = scroller.querySelector('.mobile-nav');
    var plan = placement(scroller, item, button);
    if (nav) nav.style.paddingBottom = plan.pad > 0 ? plan.pad + 'px' : '';

    var closing = collapseOthers(button);
    var expanded = false;
    var started = performance.now();
    var last = started;
    // 时间常数越大越缓。大约三个常数后停稳。
    var smoothMs = prefersReducedMotion() ? 0 : 100;

    function tick(now) {
      if (token !== openToken) return;

      var offset = itemOffset(scroller, item);
      var desired = Math.min(Math.max(0, offset - plan.targetVisual), maxScroll(scroller));
      var delta = desired - scroller.scrollTop;
      var dt = Math.min(34, Math.max(0, now - last));
      last = now;

      if (Math.abs(delta) > 0.5) {
        if (smoothMs === 0) {
          scroller.scrollTop = desired;
        } else {
          scroller.scrollTop += delta * (1 - Math.exp(-dt / smoothMs));
        }
      }

      var visual = item.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
      var arrived = Math.abs(visual - plan.targetVisual) <= 20;
      // 已经滑到头（到顶或到内容尽头）就展开，不再等尾巴。
      var cannotCloser = Math.abs(delta) <= 1;
      if (!expanded && (arrived || cannotCloser || now - started > 380)) {
        expanded = true;
        button.setAttribute('aria-expanded', 'true');
      }
      if (expanded) trimPadding(scroller);

      var opening = document.getElementById(button.getAttribute('aria-controls'));
      var stillOpening = opening && opening.getAnimations().some(function(animation) {
        return animation.playState === 'running';
      });
      if (now - started > 1100) {
        trimPadding(scroller);
        return;
      }
      // 收起或展开还在进行时继续把项定在目标位置，临时空白等内容撑住后再去掉。
      if (!expanded || stillClosing(closing) || stillOpening || (nav && nav.style.paddingBottom)) {
        window.requestAnimationFrame(tick);
      }
    }

    window.requestAnimationFrame(tick);
  }, true);
})();

/**
 * 轮播桌面端左右按钮。slide-show 上已有 previous / next。
 */
document.addEventListener('click', function(event) {
  var button = event.target.closest('.slideshow__arrow');
  if (!button) return;

  var slideshow = button.closest('slide-show');
  if (!slideshow || typeof slideshow.previous !== 'function') return;

  event.preventDefault();
  if (button.getAttribute('data-slideshow-direction') === 'prev') {
    slideshow.previous();
  } else {
    slideshow.next();
  }
});

/**
 * 尺码没选、或 Custom Size 没填完整时，不能加车，也不能结账。
 * 自定义输入在表单外面，浏览器自带校验拦不住空的三围。
 */
(function() {
  var MSG_SELECT = 'Please select a size';
  var MSG_CUSTOM = 'Please complete your custom size information';
  var MSG_CHECKOUT = 'Please select a size or complete your custom size information';
  var MEASURE_FIELDS = ['Bust', 'Waist', 'Hips', 'Hollow to Floor', 'Height (Bare Foot)', 'Heels Length'];
  var checkoutPass = false;

  function isSizeName(name) {
    return /^(size|尺寸)$/i.test(String(name || '').replace(/:\s*$/, '').trim());
  }

  function isCustomSize(value) {
    return /custom\s*size/i.test(String(value || ''));
  }

  function productScope(form) {
    return form.closest('.product-form') || form.closest('.product') || document;
  }

  function showNotice(box, message) {
    box.hidden = false;
    box.style.display = 'block';
    box.textContent = message;
  }

  function hideNotice(box) {
    if (!box) return;
    box.hidden = true;
    box.style.display = 'none';
    box.textContent = '';
  }

  function ensureProductNotice(scope) {
    var box = scope.querySelector('.custom-size-error');
    if (box) return box;

    box = document.createElement('div');
    box.className = 'custom-size-error';
    box.hidden = true;
    var anchor = scope.querySelector('.size-loop-wrap') || scope.querySelector('.product-form__variants');
    if (anchor) anchor.insertAdjacentElement('afterend', box);
    return box;
  }

  // 把输入同步进真正提交的隐藏字段，单位跟页面上的 inch / cm 走。
  function syncCustomInputs(box) {
    var unitLabel = box.querySelector('.single_custom-unit');
    var unit = unitLabel && /cm/i.test(unitLabel.textContent) ? 'cm' : 'inch';

    box.querySelectorAll('.js-custom-input').forEach(function(input) {
      var hidden = input.parentElement && input.parentElement.querySelector('.js-custom-property');
      if (!hidden) return;
      var value = input.value.trim();
      hidden.disabled = false;
      hidden.value = value ? value + unit : '';
    });
  }

  function customSizeComplete(box) {
    var inputs = box.querySelectorAll('.js-custom-input');
    if (!inputs.length) return false;

    var filled = Array.prototype.every.call(inputs, function(input) {
      return input.value.trim() !== '';
    });
    var confirmInput = box.querySelector('.js-custom-confirm');
    return filled && !!confirmInput && confirmInput.checked;
  }

  function nativeSizeMissing(scope) {
    var missing = false;

    scope.querySelectorAll('.product-form__option-selector').forEach(function(selector) {
      var nameEl = selector.querySelector('.product-form__option-name');
      if (!nameEl || !isSizeName(nameEl.textContent)) return;

      var radios = selector.querySelectorAll('input[type="radio"]');
      if (!radios.length || selector.querySelector('input[type="radio"]:checked')) return;
      missing = true;
    });

    return missing;
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 1000px)').matches;
  }

  // 返回 size / custom / 空。空表示可以加车。
  function productSizeProblem(form) {
    var scope = productScope(form);
    var module = scope.querySelector('[data-custom-size-module]');

    if (module) {
      var radios = module.querySelectorAll('.js-size-radio');
      var checked = module.querySelector('.js-size-radio:checked');
      if (radios.length && !checked) return 'size';

      if (checked && checked.getAttribute('data-custom') === 'true') {
        var customBox = scope.querySelector('.single_custom-size[data-custom-size-related="' + module.getAttribute('data-custom-size-module') + '"]') || scope.querySelector('.single_custom-size');
        if (!customBox || !customSizeComplete(customBox)) return 'custom';
        syncCustomInputs(customBox);
      }
    }

    if (nativeSizeMissing(scope)) return 'size';
    return '';
  }

  function productSizeMessage(form) {
    var problem = productSizeProblem(form);
    if (problem === 'size') return MSG_SELECT;
    if (problem === 'custom') return MSG_CUSTOM;
    return '';
  }

  function desktopTipText(problem) {
    if (problem === 'size') return MSG_SELECT;
    if (problem === 'custom') return MSG_CUSTOM;
    return '';
  }

  function sizeInfo(scope) {
    var moduleInfo = scope.querySelector('[data-custom-size-module] .product-form__option-info');
    if (moduleInfo) return moduleInfo;

    var found = null;
    scope.querySelectorAll('.product-form__option-selector').forEach(function(selector) {
      var nameEl = selector.querySelector('.product-form__option-name');
      if (nameEl && isSizeName(nameEl.textContent)) found = selector.querySelector('.product-form__option-info');
    });
    return found;
  }

  function showSizeHint(scope) {
    var info = sizeInfo(scope);
    if (!info) return;

    var hint = info.querySelector('.size-select-hint');
    if (!hint) {
      hint = document.createElement('span');
      hint.className = 'size-select-hint';
      hint.textContent = MSG_SELECT;
      var chart = info.querySelector('.product-size-chart, .product-form__option-link');
      if (chart) info.insertBefore(hint, chart);
      else info.appendChild(hint);
    }

    hint.hidden = false;
    info.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function hideSizeHint(scope) {
    var hint = scope.querySelector('.size-select-hint');
    if (hint) hint.hidden = true;
  }

  function markEmptyCustomFields(scope) {
    var box = scope.querySelector('.single_custom-size');
    if (!box) return;

    box.querySelectorAll('.js-custom-input').forEach(function(input) {
      var wrap = input.closest('.single_custom-input-wrap');
      if (!wrap) return;
      wrap.classList.toggle('is-size-missing', input.value.trim() === '');
    });

    var confirmInput = box.querySelector('.js-custom-confirm');
    var footer = box.querySelector('.single_custom-footer');
    if (footer && confirmInput) footer.classList.toggle('is-size-missing', !confirmInput.checked);
  }

  function clearEmptyCustomFields(scope) {
    scope.querySelectorAll('.is-size-missing').forEach(function(node) {
      node.classList.remove('is-size-missing');
    });
  }

  function refreshBuyTip(host, form, anchor) {
    if (!host || !form) return;

    var problem = productSizeProblem(form);
    syncPayPalGuard(host, problem);
    if (!isDesktop()) return;

    var tip = host.querySelector(':scope > .size-buy-tip');
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'size-buy-tip';
      host.appendChild(tip);
    }

    var text = desktopTipText(problem);
    tip.textContent = text;
    tip.classList.toggle('is-active', !!text);
    host.classList.toggle('is-size-incomplete', !!text);
    if (text) placeBuyTip(tip, host, anchor);
  }

  // 气泡对准当前按钮中心。上面会被吸顶导航挡住时，改放到按钮下面。
  function placeBuyTip(tip, host, anchor) {
    var gap = 10;
    tip.style.width = 'max-content';
    tip.style.bottom = 'auto';
    tip.classList.remove('is-below');

    var target = anchor || host.querySelector('[data-product-add-to-cart-button]') || host;
    var hostRect = host.getBoundingClientRect();
    var rect = target.getBoundingClientRect();
    tip.style.left = (rect.left - hostRect.left + rect.width / 2) + 'px';

    if (host.classList.contains('product-sticky-form__payment-container')) {
      tip.classList.add('is-below');
      tip.style.top = 'calc(100% + ' + gap + 'px)';
      return;
    }

    tip.style.top = '0px';
    var tipHeight = tip.offsetHeight || 36;
    var header = document.querySelector('.header');
    var headerBottom = header ? header.getBoundingClientRect().bottom : 0;

    if (rect.top - headerBottom >= tipHeight + gap) {
      tip.style.top = (rect.top - hostRect.top - tipHeight - gap) + 'px';
    } else {
      tip.classList.add('is-below');
      tip.style.top = (rect.bottom - hostRect.top + gap) + 'px';
    }
  }

  // PayPal 按钮常在 iframe 里，父页面收不到点击。挡住它，点下去走尺码提示。
  function syncPayPalGuard(host, problem) {
    var paypal = host.querySelector('.shopify-payment-button');
    if (!paypal) return;

    var guard = paypal.querySelector('.size-buy-guard');
    if (!problem) {
      if (guard) guard.remove();
      return;
    }

    if (!guard) {
      guard = document.createElement('button');
      guard.type = 'button';
      guard.className = 'size-buy-guard';
      paypal.appendChild(guard);
    }

    guard.setAttribute('aria-label', desktopTipText(problem));
  }

  function refreshBuyTips(form) {
    document.querySelectorAll('.product-form__payment-container, .product-sticky-form__payment-container').forEach(function(host) {
      var button = host.querySelector('[data-product-add-to-cart-button]');
      var hostForm = button && (button.form || document.getElementById(button.getAttribute('form') || ''));
      if (hostForm === form) refreshBuyTip(host, form);
    });
  }

  function blockProductBuy(form) {
    var scope = productScope(form);
    var problem = productSizeProblem(form);

    if (!problem) {
      hideNotice(scope.querySelector('.custom-size-error'));
      hideSizeHint(scope);
      clearEmptyCustomFields(scope);
      refreshBuyTips(form);
      return false;
    }

    if (problem === 'size') {
      clearEmptyCustomFields(scope);
      showSizeHint(scope);
    } else {
      hideSizeHint(scope);
      markEmptyCustomFields(scope);
    }

    refreshBuyTips(form);
    if (isDesktop()) {
      hideNotice(scope.querySelector('.custom-size-error'));
    } else {
      showProductNotice(form, problem === 'size' ? MSG_SELECT : MSG_CUSTOM);
    }
    return true;
  }

  function showProductNotice(form, message) {
    var scope = productScope(form);
    var box = ensureProductNotice(scope);
    if (!box) return;
    showNotice(box, message);
    box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function propertyValue(properties, key) {
    if (!properties || properties[key] == null) return '';
    return String(properties[key]).trim();
  }

  function cartItemProblem(item) {
    var properties = item.properties || {};
    var sizeProperty = propertyValue(properties, 'Size');
    var optionSize = '';
    var hasSizeOption = false;

    (item.options_with_values || []).forEach(function(option) {
      if (!isSizeName(option.name)) return;
      hasSizeOption = true;
      optionSize = String(option.value || '').trim();
    });

    if (isCustomSize(sizeProperty) || isCustomSize(optionSize)) {
      var measuresFilled = MEASURE_FIELDS.every(function(field) {
        return propertyValue(properties, field) !== '';
      });
      var confirmed = /confirm/i.test(propertyValue(properties, 'Custom Size Confirmation'));
      return measuresFilled && confirmed ? '' : 'custom';
    }

    if (Object.prototype.hasOwnProperty.call(properties, 'Size') && !sizeProperty) return 'size';
    if (hasSizeOption && !optionSize) return 'size';
    return '';
  }

  function checkoutMessage(items) {
    var needsSize = false;
    var needsCustom = false;

    (items || []).forEach(function(item) {
      var problem = cartItemProblem(item);
      if (problem === 'size') needsSize = true;
      if (problem === 'custom') needsCustom = true;
    });

    if (needsSize && needsCustom) return MSG_CHECKOUT;
    if (needsCustom) return MSG_CUSTOM;
    if (needsSize) return MSG_SELECT;
    return '';
  }

  function cartJsUrl() {
    var root = window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl;
    return (root || '/cart') + '.js';
  }

  function loadCartItems() {
    return fetch(cartJsUrl(), { headers: { Accept: 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) { return cart.items || []; });
  }

  function showCartNotice(anchor, message) {
    var parent = anchor.parentElement;
    if (!parent) return;
    var box = parent.querySelector('.cart-size-error');
    if (!box) {
      box = document.createElement('div');
      box.className = 'custom-size-error cart-size-error';
      parent.insertBefore(box, anchor);
    }
    showNotice(box, message);
    box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearCartNotices() {
    document.querySelectorAll('.cart-size-error').forEach(function(box) {
      hideNotice(box);
    });
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('#checkout-retention-popup')) return;

    var addButton = event.target.closest('[data-product-add-to-cart-button], .shopify-payment-button__button, .shopify-payment-button__more-options, .size-buy-guard');
    if (addButton) {
      var form = addButton.form || document.getElementById(addButton.getAttribute('form') || '');
      if (!form && addButton.closest('form')) form = addButton.closest('form');
      if (!form || (form.getAttribute('is') !== 'product-form' && !form.querySelector('[data-product-add-to-cart-button]'))) return;

      if (!blockProductBuy(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    var checkout = event.target.closest('button[name="checkout"], .additional-checkout-buttons, a[href*="/checkout"]');
    if (!checkout || checkoutPass) return;

    var replayTarget = event.target.closest('button, a') || event.target;
    event.preventDefault();
    event.stopImmediatePropagation();

    loadCartItems().then(function(items) {
      var cartMessage = checkoutMessage(items);
      if (!cartMessage) {
        clearCartNotices();
        checkoutPass = true;
        replayTarget.click();
        checkoutPass = false;
        return;
      }
      showCartNotice(replayTarget, cartMessage);
    }).catch(function() {
      checkoutPass = true;
      replayTarget.click();
      checkoutPass = false;
    });
  }, true);

  document.addEventListener('mouseover', function(event) {
    if (!isDesktop()) return;

    var anchor = event.target.closest('[data-product-add-to-cart-button], .shopify-payment-button, .size-buy-guard');
    if (!anchor) return;
    if (event.relatedTarget && anchor.contains(event.relatedTarget)) return;

    var host = anchor.closest('.product-form__payment-container, .product-sticky-form__payment-container');
    if (!host) return;

    var button = host.querySelector('[data-product-add-to-cart-button]');
    var form = button && (button.form || document.getElementById(button.getAttribute('form') || ''));
    if (!form) form = host.closest('form');
    if (!form) return;

    refreshBuyTip(host, form, anchor);
    if (productSizeProblem(form) === 'custom') markEmptyCustomFields(productScope(form));
  });

  document.addEventListener('change', function(event) {
    var scope = event.target.closest('.product-form');
    if (!scope) return;
    if (!event.target.closest('.size-loop-wrap, .single_custom-size, .product-form__option-selector')) return;

    var form = scope.querySelector('form[is="product-form"]');
    if (!form) return;

    var problem = productSizeProblem(form);
    if (problem !== 'size') hideSizeHint(scope);
    if (problem === 'custom' && scope.querySelector('.is-size-missing')) markEmptyCustomFields(scope);
    else if (problem !== 'custom') clearEmptyCustomFields(scope);
    if (!problem) hideNotice(scope.querySelector('.custom-size-error'));
    refreshBuyTips(form);
  });

  document.addEventListener('input', function(event) {
    if (!event.target.classList.contains('js-custom-input')) return;

    var scope = event.target.closest('.product-form');
    if (!scope) return;
    if (scope.querySelector('.is-size-missing')) markEmptyCustomFields(scope);

    var form = scope.querySelector('form[is="product-form"]');
    if (!form) return;
    if (!productSizeProblem(form)) hideNotice(scope.querySelector('.custom-size-error'));
    refreshBuyTips(form);
  });

  document.documentElement.addEventListener('cart:refresh', function() {
    loadCartItems().then(function(items) {
      var message = checkoutMessage(items);
      if (!message) clearCartNotices();
    }).catch(function() {});
  });
})();

/**
 * 商品页标题下的评分（桌面端 hidden-pocket、移动端 hidden-lap-and-up）点击后滚到 Customer Reviews。
 */
(function() {
  var REVIEW_SELECTORS = ['#judgeme_product_reviews', '.jdgm-review-widget', '#shopify-product-reviews'];

  function reviewsTarget() {
    for (var i = 0; i < REVIEW_SELECTORS.length; i++) {
      var node = document.querySelector(REVIEW_SELECTORS[i]);
      if (node) return node;
    }
    return null;
  }

  document.addEventListener('click', function(event) {
    var badge = event.target.closest('[data-scroll-to-reviews]');
    if (!badge) return;

    var target = reviewsTarget();
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', badge.getAttribute('href') || '#judgeme_product_reviews');
    }
  });
})();
